import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  NavbarToggler,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Button,
} from "reactstrap";
import { connect } from "react-redux";
import { logout } from "../../actions/actionLogin";
import { Link } from "react-router-dom";
import allApps from "../../../assets/images/apps.png";
import apps from "../../../assets/images/workspaces.svg";

import settings from "../../../assets/images/settings.png";
import notifications from "../../../assets/images/notifications.png";
import help from "../../../assets/images/help.png";
import logoutIcon from "../../../assets/images/logoutIcon.png";
import profile from "../../../assets/images/profile.png";
import { IS_ADMIN, USER_NAME } from "../../constants/Constants";

import "./Header.css";
import configure from "../../../assets/images/configure.svg";
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.dropdownRef = React.createRef();
    this.avatarRef = React.createRef();

    this.onOutsideClick = this.onOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.onOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }

  onOutsideClick(event) {
    if (
      this.state.isOpen &&
      this.dropdownRef.current &&
      this.avatarRef.current &&
      this.dropdownRef.current.contains(event.target) == false &&
      this.avatarRef.current.contains(event.target) == false
    ) {
      this.setState({
        isOpen: false
      });
    }
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  asideToggle(e) {
    e.preventDefault();
    e.target.classList.add("fa-angle-left");
    document.body.classList.toggle("aside-menu-hidden");
  }

  renderProfileDetails() {
    const userName = USER_NAME.replace(/@.*/g, "");
    const fullUserName = USER_NAME;
    const initials = USER_NAME ? USER_NAME.slice(0, 2) : "";

    return (
      <div
        ref={this.dropdownRef}
        className="dropdown-menu show"
      >
        <div className="account">
          <div className="circle">
            <span className="initials">{initials}</span>
          </div>

          <div className="details">
            <div className="username">{userName}</div>
            <div className="full-username">{fullUserName}</div>
          </div>
        </div>

        <div className="edit">
          <Link
            onClick={() => this.setState({ isOpen: false })}
            to={IS_ADMIN ? "/adminprofile" : "/userprofile"}
          >Edit Profile</Link>
        </div>

        <div className="sign-out">
          <Button
            size="sm"
            color="primary"
            onClick={() => {
              this.setState({ isOpen: false });
              this.props.history.push("/logout");
            }}
          >
            Sign Out
          </Button>
        </div>
      </div>
    );
  }

  render() {
    let lastPage = "";
    let header_logo = window.localStorage.getItem("header_logo");
    header_logo = header_logo ? header_logo : "img/headerlogo.svg";
    let elem = document.getElementById("favicon");
    let favicon_logo = window.localStorage.getItem("favicon_logo");

    if (favicon_logo != undefined) {
      elem.href = favicon_logo;
    }

    let html_title = window.localStorage.getItem("html_title");

    if (html_title != undefined) {
      document.title = html_title;
    }

    const userName = USER_NAME ? USER_NAME.slice(0, 2) : "";
    const initials = userName.charAt(0).toUpperCase() + userName.charAt(1).toLowerCase();
    const pathname =
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname;

    lastPage =
      pathname === "/dashboard"
        ? ""
        : pathname === "/userdashboard"
        ? lastPage
        : pathname;

    return (
      <header className="app-header navbar">
        <div className="flex_block">
          {!(pathname === "/userdashboard" || pathname === "/userprofile") && (
            <NavbarToggler
              className="d-lg-none"
              onClick={this.mobileSidebarToggle}
            >
              <i className="fa fa-bars" aria-hidden="true"></i>
            </NavbarToggler>
          )}
          <Link to={"/"}>
            <img
              className="header_logo"
              src={header_logo}
              height="35"
              alt="logo"
            />
          </Link>
          {IS_ADMIN && (
            <div className="appbox">
              <Link to={"/userdashboard"}>
                <button
                  className={
                    pathname === "/userdashboard" ? "active" : "app-btn"
                  }
                >
                  {" "}
                   <img src={apps} alt="apps" />{" "}
                  <span className="icon-description">Workspaces</span>
                </button>
              </Link>
              <Link to={lastPage ? lastPage : "/dashboard"}>
                <button
                  className={
                    IS_ADMIN && !(pathname === "/userdashboard")
                      ? "active"
                      : "app-btn"
                  }
                >
                  {" "}
                  <img src={configure} alt="settings" />{" "}
                  <span className="icon-description">Admin</span>
                </button>
              </Link>
            </div>
          )}
          {!IS_ADMIN && (
            <Link to={"/userdashboard"}>
              <button
                className={
                  pathname === "/userprofile"
                    ? "enable-appIcon active"
                    : "disable-appIcon"
                }
              >
                <img src={allApps} alt="allApps" />
              </button>
            </Link>
          )}
        </div>

        {userName && (
          <div
            className="navbar-right">
            <div
              ref={this.avatarRef}
              className="dropdown"
              onClick={(e) => this.setState({ isOpen: !this.state.isOpen }) }>
              <div className="circle avatar">
                <span className="initials">{initials}</span>
              </div>
            </div>
            {this.state.isOpen && this.renderProfileDetails()}
          </div>
        )}

      </header>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    logout: (logout_data) => {
      dispatch(logout(logout_data));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
